module.exports = __webpack_public_path__ + "static/media/dmggo.9e111b91.svg";